import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.4y3rEL',
    defaultMessage: 'Snapshots',
  },
  unknownUser: {
    id: 'studio./DVi5z',
    defaultMessage: 'Unknown user',
  },
  noSnapshots: {
    id: 'studio.hnit3L',
    defaultMessage: 'No snapshots available.',
  },
  error: {
    id: 'studio.fWH1j6',
    defaultMessage: 'Something went wrong when fetching the app’s snapshots.',
  },
  loading: {
    id: 'studio.s9CLUo',
    defaultMessage: 'Loading snapshots…',
  },
});
